<!--@format-->
<template>
    <div class="global-category-dropdown app-multiselect-new-wrapper">
        <label v-if="!hideLabel"> Categories </label>
        <div
            v-if="selected.length && showSelectedUp"
            class="selected-categories"
            :class="{ up: showSelectedUp }"
        >
            <div
                v-for="(category, index) in selected"
                :key="category + '_' + index"
                class="category-chips"
            >
                <span>{{ category }}</span>
                <x-svg @click.native="removeCategory(category)" />
            </div>
        </div>
        <multiselect
            :placeholder="placeholder"
            :value="value"
            label="name"
            class="app-multiselect-new category-multiselect"
            track-by="id"
            :options="categories"
            :show-labels="false"
            :clear-on-select="true"
            :close-on-select="true"
            @select="selectCategory($event)"
            @remove="removeCategory"
        >
            <template slot="tag" slot-scope="{ option }">
                <span class="custom__tag">
                    <span>{{ option.name }}</span>
                </span>
            </template>
            <template slot="option" slot-scope="{ option }">
                <div class="item">
                    <div class="name">{{ option.name }}</div>
                </div>
            </template>
            <template v-if="allowManage" slot="beforeList">
                <div class="item manage-item">
                    Manage Accounts
                    <o6-add-svg />
                </div>
            </template>
        </multiselect>
        <div
            v-if="selected.length && !showSelectedUp"
            class="selected-categories"
            :class="{ bottom: !showSelectedUp }"
        >
            <div
                v-for="(category, index) in selected"
                :key="category + '_' + index"
                class="category-chips"
            >
                <span>{{ category }}</span>
                <x-svg @click.native="removeCategory(category)" />
            </div>
        </div>
    </div>
</template>

<script>
const O6AddSvg = () => import('@/components/svg/grid/o6-add-svg');
const XSvg = () => import('@/components/svg/connectwise/x-svg');

import { GlobalCategoryService } from '@/scripts/services/global-category/global-category-service';
import Multiselect from 'vue-multiselect';
import EventBus from '@/scripts/event-bus.js';

export default {
    components: {
        multiselect: Multiselect,
        'o6-add-svg': O6AddSvg,
        'x-svg': XSvg,
    },

    props: {
        value: {
            type: Array,
            default: () => [],
        },

        allowManage: {
            type: Boolean,
            default: false,
        },

        selected: {
            type: Array,
            default: () => [],
        },

        showSelectedUp: {
            type: Boolean,
            default: false,
        },

        accountId: {
            type: Number,
            default: 0,
        },

        hideLabel: {
            type: Boolean,
            default: false,
        },

        placeholder: {
            type: String,
            default: 'Search category...',
        },
    },

    data() {
        return {
            categories: [],
            isLoading: true,
        };
    },

    created() {
        this.getCategories();
        EventBus.$on('post-category:update', this.getCategories);
    },

    beforeDestroy() {
        EventBus.$off('post-category:update', this.getCategories);
    },

    methods: {
        getCategories() {
            this.isLoading = true;

            GlobalCategoryService.getAll(this.accountId)
                .then(({ data }) => {
                    const totalItems = data.count;
                    if (totalItems === 0) {
                        return;
                    }

                    const items = data.data.map(({ Id, Name }) => ({
                        id: Id,
                        name: Name,
                    }));

                    this.categories = items;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while getting your categories.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        selectCategory(item) {
            this.$emit('input', item);
        },

        removeCategory(item) {
            this.$emit('remove', item);
        },
    },
};
</script>

<style>
.global-category-dropdown .manage-item {
    display: flex;
    justify-content: space-between;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    background-color: var(--color-background-button-primary);
    color: var(--color-text-inverse);
}

.global-category-dropdown .multiselect__content-wrapper {
    border-radius: 5px;
}

.global-category-dropdown .manage-item:hover {
    background-color: var(--color-background-button-primary-hover);
}

.global-category-dropdown .manage-item .o6-add-svg .a {
    fill: var(--color-fill-options-default);
}
/*Unknown Location*/
.global-category-dropdown .custom__tag {
    align-items: center;
    background-color: var(--color-text-subtle); 
    border-radius: 20px;
    color: var(--color-text-inverse);
    padding: 3px 10px;
    margin-right: 5px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
}

.global-category-dropdown .custom__tag svg {
    width: 10px;
}
/*Unknown Location*/
.global-category-dropdown .custom__tag svg line {
    stroke: var(--color-border-accent-white);
}

.global-category-dropdown .custom__remove {
    position: relative;
    top: 4px;
    margin-left: 10px;
    z-index: 100;
    cursor: pointer;
}

.global-category-dropdown .multiselect__tags {
    padding-bottom: 8px;
    background: var(--color-fill-field-active);
    width: 100%;
    border: 2px solid var(--color-border-field-active);
    padding: 7px 15px;
    border-radius: 20px;
    color: var(--color-text-subtle);
    outline: none;
    min-height: none;
}

.global-category-dropdown .multiselect__placeholder {
    margin-bottom: 0px;
}

.global-category-dropdown .multiselect__tags-wrap {
    display: flex;
    flex-wrap: wrap;
}

.global-category-dropdown .multiselect__option--highlight,
.global-category-dropdown .multiselect__option--highlight::after {
    background: var(--color-fill-options-hover);
    color: var(--color-text-subtle);
}

.global-category-dropdown .category-multiselect .item {
    display: flex;
    align-items: center;
}

.global-category-dropdown .category-multiselect .item .name {
    margin-left: 10px;
    text-transform: capitalize;
}

.global-category-dropdown label {
    display: block;
    font: 500 16px/1em 'Roboto';
    margin-bottom: 7px;
}

.global-category-dropdown .selected-categories {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.global-category-dropdown .selected-categories.bottom {
    margin-top: 10px;
}

.global-category-dropdown .selected-categories.up {
    margin-bottom: 8px;
}

.global-category-dropdown .selected-categories .category-chips {
    align-items: center;
    border: 1px solid var(--color-border-accent-silvergray);
    border-radius: 15px;
    display: flex;
    font-size: 12px;
    gap: 8px;
    padding: 3px 10px;
    text-transform: capitalize;
}

.global-category-dropdown .selected-categories .category-chips img {
    border-radius: 50%;
    height: 20px;
    width: 20px;
}

.global-category-dropdown .selected-categories .category-chips svg {
    cursor: pointer;
    margin-left: 12px;
    width: 10px;
}
</style>
